// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewSubmitButton_root__2K49g"};